
{
  "cta": "Order Now",
  "empty-title": "Coupon",
  "subtitles": {
    "item": "To get {amount} off select items, use this code at checkout",
    "ticket": "To get {amount} off, use this code at checkout"
  }
}
